import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Account, AccountResource, ReportResource } from '@apaq/orgkit-js';
import { addDays, format } from 'date-fns';
import { container } from 'tsyringe';
import { DialogRef } from '../../dialog/dialog-ref';
import { DATA, DIALOG } from '../../dialog/dialog.service';

@Component({
  selector: 'app-download-worksheet-dialog',
  templateUrl: './download-worksheet-dialog.component.html',
  styleUrls: ['./download-worksheet-dialog.component.scss']
})
export class DownloadWorksheetDialogComponent implements OnInit {

  form: FormGroup;
  accounts?: Account[]
  loading = false;

  constructor(private fb: FormBuilder,
    @Inject(DIALOG) private dialog: DialogRef,
    @Inject(LOCALE_ID) private locale: string,
    @Inject(DATA) private data: { date: Date, resourceId: string },
    private _accountResource: AccountResource,
    private _reportResource: ReportResource) {
    this.form = this.fb.group({
      date: [new Date()],
      accountIds: [[]],
      allAccounts: [false]
    });
  }

  async ngOnInit() {



    this.accounts = (await this._accountResource.findAll({ size: 100, sort: 'name' })).content;

    if (this.data?.date != null) {
      this.form?.get('date')?.setValue(this.data.date);
      this.form?.get('accountIds')?.setValue([this.data.resourceId]);
    }


    this.form.get('allAccounts')?.valueChanges.subscribe(value => {
      switch (value) {
        case false:
          this.form?.get('accountIds')?.enable();
          break;
        case true:
          this.form?.get('accountIds')?.disable();
          break;
      }
    });
  }

  get dateString(): string {
    return format(this.form?.get('date')?.value, 'yyyy-MM-dd');
  }

  get selectedAccountIds(): string[] {
    if (this.form!.get('allAccounts')?.value) {
      return this.accounts!.map(a => a.id);
    } else {
      return this.form?.get('accountIds')?.value;
    }
  }

  cancel() {
    this.dialog.close();
  }

  download() {
    this.loading = true;
    const filename = 'plan' + '-' + this.dateString + '.pdf';
    const allAccounts = this.form?.get('allAccounts')?.value;
    const accountIds = allAccounts ? this.accounts?.map(a => a.id) : this.form!.get('accountIds')!.value;
    const date = this.form?.get('date')?.value;
    const from = date;
    const to = addDays(date, 1);

    this._reportResource.generateWorkplan(from, to, accountIds).then(res => {
      let objectUrl = URL.createObjectURL(res);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(objectUrl);
      this.loading = false;
      this.dialog.close();
    });
  }
}
